var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-clock"},[_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.progressWidth })})]),_c('centre-spinner',{attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }